import { Button, Checkbox, Divider, Form, Input } from "antd";
import { FormItemProps } from "antd/lib";
import classes from "./AgentIndividualForm.module.css";
import { useAppSelector } from "../../../store/reduxHooks";
import { PlusOutlined } from "@ant-design/icons";
import { AgentIndivdualAward } from "./components/IndividualAward/AgentIndividualAward";
import { ModalAddContactInfo } from "../shared/ModalAddContactInfo/ModalAddContactInfo";
import { useState } from "react";
import { UI_ITODatePicker } from "../../../UI_ITO/UI_ITODatePicker/UI_ITODatePicker";

export const AgentIndividualForm = () => {
  const isEditForm = useAppSelector(
    (state) => state.adminAgentIndividualInfoSlice.isEdit,
  );
  const directorInfoProps: FormItemProps[] = [
    {
      label: <span className={classes.formItemLabel}>Фамилия</span>,
      children: (
        <>
          {isEditForm ? (
            <Input size="large" />
          ) : (
            <div className={classes.fieldValue}>Иванов</div>
          )}
        </>
      ),
      rules: [],
      className: classes.formItem,
      name: "surname",
    },
    {
      label: <span className={classes.formItemLabel}>Имя</span>,
      children: (
        <>
          {isEditForm ? (
            <Input size="large" />
          ) : (
            <div className={classes.fieldValue}>Никита</div>
          )}
        </>
      ),
      rules: [],
      className: classes.formItem,
      name: "name",
    },
    {
      label: <span className={classes.formItemLabel}>Отчество</span>,
      children: (
        <>
          {isEditForm ? (
            <Input size="large" />
          ) : (
            <div className={classes.fieldValue}>Петрович</div>
          )}
        </>
      ),
      rules: [],
      className: classes.formItem,
      name: "patronymic",
    },
    {
      label: <span className={classes.formItemLabel}>Электронная почта</span>,
      children: isEditForm ? (
        <Input size="large" />
      ) : (
        <div className={classes.fieldValue}>her@mail.ru</div>
      ),
      rules: [],
      className: classes.formItem,
      name: "email",
    },
    {
      label: <span className={classes.formItemLabel}>Телефон</span>,
      children: isEditForm ? (
        <Input size="large" />
      ) : (
        <div className={classes.fieldValue}>+7 999 999 99 99</div>
      ),
      rules: [],
      className: classes.formItem,
      name: "phoneNumber",
    },
  ];

  const contactInfoProps: FormItemProps[] = [
    {
      label: <span className={classes.formItemLabel}>Фамилия</span>,
      children: isEditForm ? (
        <Input size="large" />
      ) : (
        <div className={classes.fieldValue}>Иванов</div>
      ),

      rules: [],
      className: classes.formItem,
      name: "surname",
    },
    {
      label: <span className={classes.formItemLabel}>Имя</span>,
      children: isEditForm ? (
        <Input size="large" />
      ) : (
        <div className={classes.fieldValue}>Никитаы</div>
      ),
      rules: [],
      className: classes.formItem,
      name: "name",
    },
    {
      label: <span className={classes.formItemLabel}>Отчество</span>,
      children: isEditForm ? (
        <Input size="large" />
      ) : (
        <div className={classes.fieldValue}>Петрович</div>
      ),
      rules: [],
      className: classes.formItem,
      name: "patronymic",
    },
    {
      label: <span className={classes.formItemLabel}>Электронная почта</span>,
      children: isEditForm ? (
        <Input size="large" />
      ) : (
        <div className={classes.fieldValue}>pochta@mail.ru</div>
      ),
      rules: [],
      className: classes.formItem,
      name: "email",
    },
    {
      label: <span className={classes.formItemLabel}>Телефон</span>,
      children: isEditForm ? (
        <Input size="large" />
      ) : (
        <div className={classes.fieldValue}>+7 999 999 99 99</div>
      ),
      rules: [],
      className: classes.formItem,
      name: "phoneNumber",
    },
  ];

  const infoOrganizationFields: FormItemProps[] = [
    {
      label: (
        <span className={classes.formItemLabel}>Наименование организации</span>
      ),
      children: isEditForm ? (
        <Input size="large" />
      ) : (
        <div className={classes.fieldValue}>Навзвание организации</div>
      ),
      rules: [],

      className: classes.formItem,
      rootClassName: classes.rootFormItem,
    },
    {
      label: <span className={classes.formItemLabel}>ИНН</span>,
      children: isEditForm ? (
        <Input size="large" />
      ) : (
        <div className={classes.fieldValue}>1231241243</div>
      ),
      rules: [],
      className: classes.formItem,
      rootClassName: classes.rootFormItem,
    },
    {
      label: <span className={classes.formItemLabel}>ОГРН</span>,
      children: isEditForm ? (
        <Input size="large" />
      ) : (
        <div className={classes.fieldValue}>1344132132414</div>
      ),
      rules: [],

      rootClassName: classes.rootFormItem,
    },
    {
      label: <span className={classes.formItemLabel}>Почтовый адрес</span>,
      children: isEditForm ? (
        <Input size="large" />
      ) : (
        <div className={classes.fieldValue}>pochta@mail.ru</div>
      ),
      rules: [],
      rootClassName: classes.rootFormItem,
    },
    {
      label: <span className={classes.formItemLabel}>Телефон</span>,
      children: isEditForm ? (
        <Input size="large" />
      ) : (
        <div className={classes.fieldValue}>+7 999 999 99 99</div>
      ),
      rules: [],
      rootClassName: classes.rootFormItem,
    },
    {
      label: <span className={classes.formItemLabel}>КПП</span>,
      children: isEditForm ? (
        <Input size="large" />
      ) : (
        <div className={classes.fieldValue}>123123123</div>
      ),
      rules: [],
      rootClassName: classes.rootFormItem,
    },
    {
      label: <span className={classes.formItemLabel}>Банк агента</span>,
      children: isEditForm ? (
        <Input size="large" />
      ) : (
        <div className={classes.fieldValue}>Банк</div>
      ),
      rules: [],
      rootClassName: classes.rootFormItem,
    },

    {
      label: <span className={classes.formItemLabel}>БИК банка</span>,
      children: isEditForm ? (
        <Input size="large" />
      ) : (
        <div className={classes.fieldValue}>12321342143</div>
      ),
      rules: [],
      rootClassName: classes.rootFormItem,
    },
    {
      label: <span className={classes.formItemLabel}>Корр счет банка</span>,
      children: isEditForm ? (
        <Input size="large" />
      ) : (
        <div className={classes.fieldValue}>1232413214</div>
      ),
      rules: [],
      rootClassName: classes.rootFormItem,
    },
    {
      label: (
        <span className={classes.formItemLabel}>Расчетный счет агента</span>
      ),
      children: isEditForm ? (
        <Input size="large" />
      ) : (
        <div className={classes.fieldValue}>213321311</div>
      ),
      rules: [],
      rootClassName: classes.rootFormItem,
    },
  ];

  const [modalAddContactOpen, setModalAddContactOpen] = useState(false);

  return (
    <>
      <Form className={classes.form} layout="vertical">
        <div className={classes.pageAgentSectionInfo}>
          <Divider
            orientation="left"
            orientationMargin={"0"}
            className={classes.pageAgentDivider}
          >
            Информация о руководителе
          </Divider>

          <div className={classes.contactInfoContainer}>
            <div className={classes.fields}>
              {directorInfoProps.map((el) => {
                return <Form.Item key={el.name} {...el}></Form.Item>;
              })}
            </div>
          </div>
        </div>

        <div className={classes.pageAgentSectionInfo}>
          <Divider
            orientation="left"
            orientationMargin={"0"}
            className={classes.pageAgentDivider}
          >
            Контактное лицо
          </Divider>

          <div className={classes.contactInfoContainer}>
            <div className={classes.fields}>
              {contactInfoProps.map((el) => {
                return <Form.Item key={el.name} {...el}></Form.Item>;
              })}
            </div>

            <div>
              <Button
                size="large"
                iconPosition="start"
                icon={<PlusOutlined />}
                onClick={() => {
                  setModalAddContactOpen(true);
                }}
                className={classes.pageAgentAddContact}
              >
                Добавить контактное лицо
              </Button>
            </div>
          </div>
        </div>

        <div className={classes.pageAgentSectionInfo}>
          <Divider
            orientation="left"
            orientationMargin={"0"}
            className={classes.pageAgentDivider}
          >
            Информация о руководителе
          </Divider>

          <div className={classes.organizationInfoContainer}>
            {infoOrganizationFields.map((el) => {
              return <Form.Item {...el} key={el.name}></Form.Item>;
            })}
          </div>

          <div className={classes.responsibleManager}>
            <Form.Item
              className={classes.formItem}
              label="Ответственный мененджер"
            >
              <Input size="large" />
            </Form.Item>
          </div>
        </div>

        <div className={classes.pageAgentSectionInfo}>
          <Divider
            orientation="left"
            orientationMargin={"0"}
            className={classes.pageAgentDivider}
          >
            Информация об индивидуальном вознаграждении
          </Divider>

          <AgentIndivdualAward />
        </div>

        <div className={classes.pageAgentSectionInfo}>
          <Divider
            orientation="left"
            orientationMargin="0"
            className={classes.pageAgentDivider}
          >
            Информация о договоре
          </Divider>

          <div className={classes.formContractInfo}>
            <Checkbox>Договор подписан</Checkbox>

            <div className={classes.contractInfoContainer}>
              <Form.Item className={classes.formItem} label="Номер договора">
                <Input defaultValue={"243222"} size="large" />
              </Form.Item>

              <Form.Item className={classes.formItem} label="Дата договора">
                <UI_ITODatePicker className={classes.datePicker} />
              </Form.Item>

              <Form.Item className={classes.formItem} label="Контактные лица">
                <Input
                  defaultValue={"Корсукова Анна Генадьевна"}
                  size="large"
                />
              </Form.Item>
            </div>
          </div>
        </div>
      </Form>

      <ModalAddContactInfo
        modalProps={{
          open: modalAddContactOpen,
          onCancel: () => setModalAddContactOpen(false),
        }}
        cancelButtonProps={{
          onClick: () => {
            setModalAddContactOpen(false);
          },
        }}
      />
    </>
  );
};
